// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2iIyK","label":"SetPasswdForm_label__igXjv"};